module.exports = __webpack_public_path__ + "static/media/rbc_logo.50baf711.png";